<template>
  <Layout />
</template>

<script>
import Layout from './components/layout/Layout.vue'

export default {
  name: 'App',
  components: {
    Layout
  },
  mounted() {
    // Dispatch custom event to signal that the app is ready for prerendering
    document.dispatchEvent(new Event('render-event'))
  }
}
</script>

<style>
/* Global styles are loaded via index.html */
</style>
